import { IKChainType } from 'stores/posingStore';

// Default pose configuration
export const DEFAULT_POSE_BVH_PATH = '/default-pose-mode.bvh';

// Auto select an IK Chain when loading
export const DEFAULT_IK_CHAIN = IKChainType.RightArm;

// Keys match up to values of IKChainType
export const IK_SELECTORS: Record<
  string,
  {
    type: IKChainType;
    label: string;
    chainKey: string;
    stateMachine: string;
    modeList: Array<{ type: string; label: string; hotkey: string }>;
  }
> = {
  right_arm: {
    type: IKChainType.RightArm,
    label: 'Right Arm',
    chainKey: 'rightArm',
    stateMachine: 'limb',
    modeList: [
      { type: 'translate', label: 'Move Wrist', hotkey: 'T' },
      { type: 'rotate', label: 'Rotate Wrist', hotkey: 'R' },
      { type: 'twist', label: 'Twist Elbow', hotkey: 'Y' },
    ],
  },

  left_arm: {
    type: IKChainType.LeftArm,
    label: 'Left Arm',
    chainKey: 'leftArm',
    stateMachine: 'limb',
    modeList: [
      { type: 'translate', label: 'Move Wrist', hotkey: 'T' },
      { type: 'rotate', label: 'Rotate Wrist', hotkey: 'R' },
      { type: 'twist', label: 'Twist Elbow', hotkey: 'Y' },
    ],
  },

  right_leg: {
    type: IKChainType.RightLeg,
    label: 'Right Leg',
    chainKey: 'rightLeg',
    stateMachine: 'limb',
    modeList: [
      { type: 'translate', label: 'Move Ankle', hotkey: 'T' },
      { type: 'rotate', label: 'Rotate Foot', hotkey: 'R' },
      { type: 'twist', label: 'Twist Knee', hotkey: 'Y' },
    ],
  },

  left_leg: {
    type: IKChainType.LeftLeg,
    label: 'Left Leg',
    chainKey: 'leftLeg',
    stateMachine: 'limb',
    modeList: [
      { type: 'translate', label: 'Move Ankle', hotkey: 'T' },
      { type: 'rotate', label: 'Rotate Foot', hotkey: 'R' },
      { type: 'twist', label: 'Twist Knee', hotkey: 'Y' },
    ],
  },

  spine: {
    type: IKChainType.Spine,
    label: 'Spine',
    chainKey: 'spine',
    stateMachine: 'spine',
    modeList: [
      { type: 'translate', label: 'Move', hotkey: 'T' },
      { type: 'twist', label: 'Twist', hotkey: 'Y' },
    ],
  },

  neck: {
    type: IKChainType.Neck,
    label: 'Neck',
    chainKey: 'neck',
    stateMachine: 'fkrotate',
    modeList: [{ type: 'rotate', label: 'Rotate Neck', hotkey: 'R' }],
  },

  head: {
    type: IKChainType.Head,
    label: 'Head',
    chainKey: 'head',
    stateMachine: 'fkrotate',
    modeList: [{ type: 'rotate', label: 'Rotate Head', hotkey: 'R' }],
  },

  left_toe: {
    type: IKChainType.LeftToe,
    label: 'Left Toe',
    chainKey: 'leftToe',
    stateMachine: 'fkrotate',
    modeList: [{ type: 'twist', label: 'Spin Toe', hotkey: 'Y' }],
  },

  right_toe: {
    type: IKChainType.RightToe,
    label: 'Right Toe',
    chainKey: 'rightToe',
    stateMachine: 'fkrotate',
    modeList: [{ type: 'twist', label: 'Spin Toe', hotkey: 'Y' }],
  },

  pelvis: {
    type: IKChainType.Pelvis,
    label: 'Pelvis',
    chainKey: 'pelvis',
    stateMachine: 'fkroot',
    modeList: [
      { type: 'translate', label: 'Move', hotkey: 'T' },
      { type: 'rotate', label: 'Rotate', hotkey: 'R' },
      { type: 'root', label: 'Root Control', hotkey: 'G' },
    ],
  },
};
